import styled from 'styled-components';

export const Container = styled.div`
  padding: 8px 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;

  form{
    width: 100%;
  }
`;
